import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { AppId, getAppId, UploadIconContentTypes } from "api";
import { Credentials } from "auth";
import { ClientApp } from "models";
import { State } from "redux/state";

export type UploadIcon = "UPLOAD_ICON";
export const UPLOAD_ICON: UploadIcon = "UPLOAD_ICON";
export type UploadIconSuccess = "UPLOAD_ICON_SUCCESS";
export const UPLOAD_ICON_SUCCESS: UploadIconSuccess = "UPLOAD_ICON_SUCCESS";
export type UploadIconFailure = "UPLOAD_ICON_FAILURE";
export const UPLOAD_ICON_FAILURE: UploadIconFailure = "UPLOAD_ICON_FAILURE";

export interface UploadIconAction extends Action {
    payload: {
        credentials: Credentials;
        appId: string;
        blob: Blob;
        contentType: UploadIconContentTypes;
    };
    type: UploadIcon;
}

export function uploadIcon(
    appId: AppId,
    blob: Blob,
    contentType: UploadIconContentTypes
): ThunkAction<void, State, undefined, UploadIconAction> {
    return (dispatch: Dispatch<UploadIconAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(uploadIconWithCredentials(credentials, appId, blob, contentType));
    };
}

function uploadIconWithCredentials(
    credentials: Credentials,
    appId: AppId,
    blob: Blob,
    contentType: UploadIconContentTypes
): UploadIconAction {
    return {
        payload: {
            appId: getAppId(appId),
            blob,
            contentType,
            credentials
        },
        type: UPLOAD_ICON
    };
}

export interface UploadIconSuccessAction extends Action {
    payload: {
        app: ClientApp;
    };
    type: UploadIconSuccess;
}

export function uploadIconSuccess(app: ClientApp): UploadIconSuccessAction {
    return {
        payload: {
            app
        },
        type: UPLOAD_ICON_SUCCESS
    };
}

export interface UploadIconFailureAction extends Action {
    payload: {
        error: Error;
    };
    type: UploadIconFailure;
}

export function uploadIconFailure(error: Error): UploadIconFailureAction {
    return {
        payload: {
            error
        },
        type: UPLOAD_ICON_FAILURE
    };
}
